import { Link } from "react-router-dom";
import useSeo from "@/lib/useSeo";

export default function NotFound() {
  useSeo({
    title: "Page Not Found | ClariDent RCM",
    description: "The page you are looking for could not be found on the ClariDent RCM website.",
    robots: "noindex, follow",
  });

  return (
    <main data-testid="notfound-page" className="max-w-3xl mx-auto px-6 py-32 text-center">
      <p className="text-xs tracking-[0.25em] uppercase font-bold text-teal-600 mb-4">404</p>
      <h1 className="font-display text-5xl sm:text-6xl tracking-tighter font-black text-navy-900">Page not found</h1>
      <p className="mt-6 text-base sm:text-lg text-slate-600">
        The page you're looking for doesn't exist or may have moved.
      </p>
      <Link
        to="/"
        data-testid="notfound-home-btn"
        className="mt-9 inline-block rounded-full bg-teal-600 px-8 py-3.5 text-sm font-bold text-white transition-all duration-200 hover:bg-teal-700 hover:-translate-y-0.5 hover:shadow-lg"
      >
        Back to homepage
      </Link>
    </main>
  );
}
